import { Link } from 'react-router-dom';
import HeadingStyle from '../../../../components/heading-style/heading-style';
import InstagramIcon from '../../../../components/icons/instagram-icon';
import * as Utility from '../../../../core/utility';

import React, { useState } from 'react'
import { Checkbox, FormControlLabel, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery } from '@mui/material';
import { CurrencyRupee, YouTube } from '@mui/icons-material';
import SwitchButton from '../../../../components/switch-button/switch-button';
import { LoadingButton } from '@mui/lab';
import dayjs from 'dayjs';
import { convert } from 'html-to-text'
import MaterialSymbol from '../../../../components/icons/material-symbol';
import MobileProposalSheet from './MobileProposalSheet';
import { BASE_URL_UI } from '../../../../config/config';

const diffMethods: Utility.Methods = new Utility.Methods();

type Props = {
  checkTermsCheckbox: boolean;
  campaignDetail: any;
  myref?: any;
  handleSubmit: () => void;
  deliverables: any;
  handleApply: any;
  campaign_cost_model_value: any;
  campaign_cost_model?: any;

  handleCost: any;
  costPerUnitError: { status: boolean, message: string };
  handleSwitch: any;
  totalAmount: number;
  userReducer: any;
  proposalChats: any;
  comment: string;
  setComment: any;
  errorTerms: boolean;
  setCheckTermsCheckBox: any;
  handleCancel: () => void;
  loading: boolean;
  showApply:boolean;
}
interface InputProps {
  handleCost: (
    index: number,
    qty: number,
    value: string,
    skipqty: boolean,
  ) => void;
  index: number;
  qty: number;
  skipAdd: boolean;
  placeholder?: string;
  type?:number;
  value?:string;
}

const InputField: React.FC<InputProps> = (props: InputProps) => {
  const handleNumericChange = (e:any) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) { 
      if (props.handleCost) {
        props.handleCost(props.index, props.qty, value, props.skipAdd);
      }
    }
  };
  return (
    <TextField
      size="small"
      type="text"
      inputMode="numeric" 
      style={{ width: `100%` }}
      id={`id_${props.index}_input_field`}
      defaultValue="0"
      placeholder={props.placeholder}
      onChange={handleNumericChange}
      InputProps={{
        startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
      }}
      InputLabelProps={{ shrink: false }}
      label=" "
      variant="outlined"
    />
  );
};

// const InputField: React.FC<InputProps> = (props: InputProps) => {
//   const handleNumericChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const value = e.target.value;

//     // Allow only numbers (no decimal, +, -, or other characters)
//     if (/^\d*$/.test(value)) {
//       if (props.handleCost) {
//         props.handleCost(props.index, props.qty, value, props.skipAdd);
//       }
//     } else {
//       // If invalid character is found, replace the value with valid numbers
//       e.target.value = value.replace(/\D/g, ''); // Remove any non-numeric character
//     }
//   };

//   const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     // Allow only digits, backspace, tab, arrow keys, and delete
//     const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
//     const isNumber = /^[0-9]$/.test(e.key); // Allow only numbers (0-9)

//     if (!isNumber && !allowedKeys.includes(e.key)) {
//       e.preventDefault(); // Block any non-numeric keypresses
//     }
//   };

//   return (
//     <TextField
//       size="small"
//       type="text" // Using "tel" type as it sometimes improves numeric behavior on mobile
//       inputMode="numeric" // Ensures numeric keypad on mobile devices
//       style={{ width: `100%` }}
//       id={`id_${props.index}_input_field`}
//       defaultValue=""
//       placeholder={props.placeholder}
//       onChange={handleNumericChange} // Validate on change to handle pasted input
//       onKeyDown={handleKeyDown} // Block invalid keypresses
//       InputProps={{
//         startAdornment: (
//           <InputAdornment position="start">
//             <CurrencyRupee className="fs-18" />
//           </InputAdornment>
//         ),
//         inputProps: {
//           inputMode: "numeric", // Numeric keypad on mobile
//           pattern: "\\d*", // Only numeric input pattern
//         },
//       }}
//       InputLabelProps={{ shrink: false }}
//       label=" "
//       variant="outlined"
//     />
//   );
// };


// const InputField: React.FC<InputProps> = (props) => {
//   const [val, setVal] = React.useState("");

//   // ✅ preserve value per row
//   React.useEffect(() => {
//     setVal((prev) => prev); // keeps existing value
//   }, [props.index]);

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const clean = e.target.value.replace(/\D/g, "");

//     setVal(clean);
//     props.handleCost(props.index, props.qty, clean, props.skipAdd);
//   };

//   return (
//     <TextField
//       size="small"
//       type="text"
//       inputMode="numeric"
//       value={val}
//       onChange={handleChange}
//       style={{ width: "100%" }}
//       InputProps={{
//         startAdornment: (
//           <InputAdornment position="start">
//             <CurrencyRupee className="fs-18" />
//           </InputAdornment>
//         ),
//       }}
//       variant="outlined"
//     />
//   );
// };

// const InputField: React.FC<InputProps> = (props) => {

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     let clean = e.target.value.replace(/\D/g, "");

//     // remove leading zeros
//     if (clean.length > 1 && clean.startsWith("0")) {
//       clean = clean.replace(/^0+/, "");
//     }

//     props.handleCost(
//       props.index,
//       props.qty,
//       clean || "0",
//       props.skipAdd
//     );
//   };

//   return (
//     <TextField
//       size="small"
//       type="text"
//       inputMode="numeric"
//       value={props.value ?? "0"}   // ✅ SINGLE SOURCE OF TRUTH
//       onChange={handleChange}
//       style={{ width: "100%" }}
//       InputProps={{
//         startAdornment: (
//           <InputAdornment position="start">
//             <CurrencyRupee className="fs-18" />
//           </InputAdornment>
//         ),
//       }}
//       variant="outlined"
//     />
//   );
// };
const SubmitAProposal = (props: Props) => {
  
  let campaignDescription = convert(props?.campaignDetail?.campaign_description) || ''; 
  let limitedDescription = campaignDescription.slice(0, 150);
  if (campaignDescription.length > 150) {
    limitedDescription += '...';
  }
  const isMobile = useMediaQuery("(max-width:768px)");

  const isPaidCampaign =
  props.campaign_cost_model_value &&
  props.campaignDetail.campaign_type?.toLowerCase() === "paid";

const getLabel = (item: string, qty: number) => {
  switch (item) {
    case "ig_reel":
      return "Reel";
    case "ig_story":
      return "Story";
    case "ig_static":
      const staticQty =
        props.deliverables.find(
          (d: any) => d.deliverable_item === "ig_static_image"
        )?.qty || 0;
      return `Static Images - ${staticQty}`;
    case "yt_shorts":
      return "Shorts";
    case "yt_dedicated_video":
      return "Dedicated Video";
    case "yt_integrated_video":
      return "Integrated Video";
    case "digital_rights":
      return `Digital Rights (${qty} days)`;
    case "available_for_exclusivity":
      return `Exclusivity (${qty} days)`;
    default:
      return item;
  }
};

const isSpecialCase = (item: string) =>
  ["digital_rights", "available_for_exclusivity"].includes(item);

const MobileRow = ({ res, index }: any) => {
  return (
    <>
    <div className="mobile-table-row">
      <div className="row-top">
        <span className="row-top-deliverable">
          {res.deliverable_item === "ig_reel" && "Reel"}
          {res.deliverable_item === "ig_story" && "Story"}
          {res.deliverable_item === "yt_shorts" && "Shorts"}
          {res.deliverable_item === "yt_dedicated_video" && "Dedicated Video"}
          {res.deliverable_item === "yt_integrated_video" && "Integrated Video"}
        </span>

        <span className="row-top-deliverable">{res.qty}</span>

        {/* ✅ Cost per unit */}
        <span className="paid-campaign-col">
          <InputField
            index={index}
            qty={res.qty}
            skipAdd={false}
            handleCost={props.handleCost}
             value={res.price}
          />
        </span>

        {/* ✅ Negotiable */}
        <span className="paid-campaign-col">
          <SwitchButton
            handleSwitch={props.handleSwitch}
            index={index}
          />
        </span>
      </div>

      {props.costPerUnitError?.status && (
        <span className="error pt-1">
          {props.costPerUnitError.message}
        </span>
      )}
    </div>
    <TableContainer
          className="common-table table-responsive bdr-rad-0"
        >
          <Table
            stickyHeader
            aria-label="simple table"
          >
            <TableHead className='common-table-header'>
              <TableRow>
                <TableCell align="left">
                  Deliverables
                </TableCell>
                <TableCell align="left">Qty</TableCell>
                {props.campaign_cost_model_value && (
                  <>
                    {(props.campaignDetail.campaign_type + "")
                      .toLocaleLowerCase()
                      .includes("paid") && (
                        <>
                          <TableCell align="left" style={{minWidth:'150px'}}>Cost per Unit</TableCell>
                        {/* <TableCell align="left" style={{minWidth:"180px"}}>Total Cost</TableCell> */}
                    <TableCell align="left" style={{minWidth:"100px", paddingLeft:'0', paddingRight:'0'}}>Is this cost negotiable?</TableCell>
                        </>
                      )}
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody className="common-table-body">
              {(props.deliverables?.length > 0) && props.deliverables &&
                props.deliverables?.map((res: any, index: number) => {
                  if (res?.deliverable_item === "ig_reel") {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Reel</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value && (
                          <>
                            {(props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                                <>
                                  <TableCell>
                                    <InputField
                                      index={index}
                                      qty={res.qty}
                                      skipAdd={false}
                                      handleCost={props.handleCost}
                                    />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                  </TableCell>
                                  {/* <TableCell><TextField
                                    size='small'
                                    disabled
                                    label=""
                                    defaultValue={res.price}
                                    value={res.price}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                    }}
                                  />
                                  </TableCell> */}
                                  <TableCell className='switch-cell'>
                                    <SwitchButton
                                      handleSwitch={props.handleSwitch}
                                      index={index}
                                    />
                                  </TableCell>
                                </>
                              )}
                          </>
                        )}
                      </TableRow>
                    );
                  } else if (res.deliverable_item === "ig_story") {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Story</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}

                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                /></TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (
                    res.deliverable_item === "ig_static"
                  ) {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>
                          Static <br className='d-md-none' />  Images - {
                            props.deliverables.filter((item: any) => item.deliverable_item === "ig_static_image")[0]?.qty
                          }
                        </TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell> <TextField
                                size='small'
                                disabled
                                id="outlined-disabled"
                                label=""
                                defaultValue={res.price}
                                value={res.price}
                                InputProps={{
                                  startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                }}
                              /></TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (res.deliverable_item === "yt_shorts") {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Shorts</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                
                                <CurrencyRupee fontSize="small" />{" "}
                                    {res.price}
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                />

                              </TableCell> */}
                              <TableCell className='switch-cell' width={100}>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (
                    res.deliverable_item === "yt_dedicated_video"
                  ) {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Dedicated Video</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                />
                              </TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (
                    res.deliverable_item === "yt_integrated_video"
                  ) {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Integrated Video</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                />
                              </TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (res.deliverable_item === "digital_rights") {
                    return (
                      <>
                        <TableRow className="common-table-blank-row">
                          <TableCell colSpan={5} className='p-0'><hr /></TableCell>
                        </TableRow>
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell className='pb-0' colSpan={4}>Digital Rights {res.qty} days</TableCell>
                        </TableRow>
                        <TableRow
                          key={index}
                          className='pt-0'
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >

                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell colSpan={3}>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={true}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell> {res.price}</TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                      </>
                    );
                  } else if (
                    res.deliverable_item === "available_for_exclusivity"
                  ) {
                    return (
                      <>
                        <TableRow>
                          <TableCell className='pb-0' colSpan={4}>Exclusivity {res.qty} days</TableCell>
                        </TableRow>
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell colSpan={3}>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={true}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell> {res.price}</TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                        {props.campaignDetail.campaign_type === "Barter" && 
                          <TableRow>
                            <TableCell className='pb-0' colSpan={4}>&nbsp;</TableCell>
                          </TableRow>
                        }
                        {/* <TableRow className="common-table-blank-row">
                          <TableCell colSpan={5} className='p-0'><hr /></TableCell>
                        </TableRow> */}
                      </>
                    );
                  }

                  return null;
                })}
              {/* PACKAGE COST */}
              {!props.campaign_cost_model_value && (
                <>
                  {props.deliverables?.length > 0 && props.deliverables &&
                    props.deliverables?.map((res: any, index: number) => {
                      if (
                        (res.deliverable_item + "").toLocaleLowerCase() ===
                        "package cost 1"
                      ) {
                        return (
                          <>
                          <TableRow className='row-package-cost'
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell>{res.deliverable_item} </TableCell>

                            
                            {/* <> */}
                            <TableCell colSpan={2}>
                              <InputField
                                index={index}
                                qty={res.qty}
                                skipAdd={true}
                                handleCost={props.handleCost}
                                placeholder="0"
                              />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                            </TableCell>
                            
                            
                            {/* </> */}

                          </TableRow>
                          <TableRow>
                          <TableCell>Is this cost negotiable? </TableCell>
                            <TableCell className='switch-cell'>
                              <SwitchButton
                                handleSwitch={props.handleSwitch}
                                index={index}
                              />
                            </TableCell>
                          </TableRow>
                          </>

                        );
                      }

                      return null; // JSON.stringify(deliverables);
                    })}
                </>

              )}

              {
                props.campaignDetail.campaign_type !== "Barter" && (
                  <>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell className='py-3' colSpan={!props.campaign_cost_model_value ? 1 : 1}><strong>Total Amount:</strong>{" "}</TableCell>
                      <TableCell className='py-3' colSpan={!props.campaign_cost_model_value ? 1 : 2}>
                        <TextField
                          size='small'
                          className='w-100'
                          disabled
                          label=""
                          defaultValue={props.totalAmount}
                          value={props.totalAmount}
                          InputProps={{
                            startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                          }}
                        />
                      </TableCell>
                      {props?.campaign_cost_model?.includes("Package") && <TableCell>&nbsp;</TableCell>}
                    </TableRow>
                  </>
                )
              }

            </TableBody>


          </Table>
        </TableContainer>
        </>
  );
};
  // console.log("props?.campaignDetail", props?.campaignDetail)
  return (
    <>
    <div className={`submit-proposal-initial ${isMobile ? "influencer-app mobile-bottom-layout" : ""}`} >
      <div className={`submit-proposal-card wo-bdr ${isMobile && 'd-none'} `}>
        <div className="row">
          <div className="col">
            <HeadingStyle className='' title="Submit a proposal" />
          </div>
        </div>
      </div>
      {/* PROPOSAL DETAIL INFO */}
      <div className='submit-proposal-card submit-proposal-initial-detail'>
        <div className='submit-proposal-initial-detail__left'>
          <h3>Campaign Details
            
          </h3>
          <div className='submit-proposal-initial-detail__left__top'>
            <div className='submit-proposal-initial-detail__left__top_left'>
              <span className="d-none d-md-block color-blk-5d fs-14 mb-1">Posted  {diffMethods.calculateDaysDifference(new Date(props?.campaignDetail?.posted_at), new Date())} days ago</span>
              <span className='submit-proposal-camp-title'>{props?.campaignDetail?.campaign_title}</span>
              
              
            </div>
           
            <span className='badge align-self-start'>{(
              props?.campaignDetail?.campaign_platform + ''
            ).toLocaleLowerCase() === 'instagram' ? (
              <InstagramIcon />
            ) : (
                <YouTube style={{marginRight: '5px'}} />
            )}{props?.campaignDetail?.campaign_type}
            </span>
          </div>
          {props?.campaignDetail?.campaign_description &&
            <div className='camp-description'>
              {/* {convert(props?.campaignDetail?.campaign_description)} */}
              {limitedDescription}
            </div>
          }

          <Link to={`/influencer/campaign/campaigndetails?campaignId=${props?.campaignDetail?.campaign_id}&smId=${props?.campaignDetail?.smId}`} className="btn btn-text-link">View the campaign brief</Link>

        </div>
        <div className='submit-proposal-initial-detail__right'>
          {/* CAMPAIGN DURATION INFO */}
          <div className='dashboard-card-camp-dur'>
            <div className='infl-det-list-sec proposal-dur-info'>
              <div className='infl-det-list'>
                <div className='infl-det-list-icon'>
                  <MaterialSymbol iconName='alarm' fontweight='200' />
                </div>
                <div className='infl-det-list-content'>
                  <strong>{dayjs(props?.campaignDetail?.proposal_dt).format('LL')} </strong>
                  <ul>
                    <li>Proposal Deadline</li>
                  </ul>
                </div>

              </div>
              <div className='infl-det-list'>
                <div className='infl-det-list-icon'>
                  <MaterialSymbol iconName='calendar_month' fontweight='200' />
                </div>
                <div className='infl-det-list-content'>
                  <strong>{dayjs(props?.campaignDetail?.go_live_dt).format('LL')} </strong>
                  <ul>
                    <li>Campaign Live Date</li>
                  </ul>
                </div>

              </div>

            </div>
          </div>
          {/* END CAMPAIGN DURATION INFO */}
        </div>
      </div>
      {/* submit-proposal-form  */}
      <div className='submit-proposal-card'>
        {props.campaignDetail.campaign_type !== "Barter" && (
          <h3 className='mb-2 mobile-title'>Collaboration Costs</h3>
          )}
        {props.campaignDetail.campaign_type === "Barter" && (
            <h3 className='mb-2 mobile-title'>Collaborations</h3>
          )}
        {isMobile ? (
          <>
          <div className="mobile-table">
  {/* <div className={`mobile-table-header ${isPaidCampaign ? 'paid-table-header': " "}`}>
    <span className={`${isPaidCampaign ? 'paid-campaign-col': " "}`}>Deliverables</span>
    <span className={`${isPaidCampaign ? 'paid-campaign-col': " "}`}>Qty</span>
    {isPaidCampaign && (
      <>
        <span className={`${isPaidCampaign ? 'paid-campaign-col': " "}`}>Cost per Unit</span>
        <span className={`${isPaidCampaign ? 'paid-campaign-col': " "}`}>Negotiable?</span>
      </>
    )}
  </div> */}
    <TableContainer
          className="common-table table-responsive bdr-rad-0"
        >
          <Table
            stickyHeader
            aria-label="simple table"
          >
            <TableHead className=''>
              <TableRow>
                <TableCell align="left">
                  Deliverables
                </TableCell>
                <TableCell align="left">Qty</TableCell>
                {props.campaign_cost_model_value && (
                  <>
                    {(props.campaignDetail.campaign_type + "")
                      .toLocaleLowerCase()
                      .includes("paid") && (
                        <>
                          <TableCell align="left" style={{minWidth:'120px'}}>Cost per Unit</TableCell>
                        {/* <TableCell align="left" style={{minWidth:"180px"}}>Total Cost</TableCell> */}
                    <TableCell align="left" style={{minWidth:"100px", paddingLeft:'0', paddingRight:'0'}}>Negotiable?</TableCell>
                        </>
                      )}
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody className="common-table-body">
              {(props.deliverables?.length > 0) && props.deliverables &&
                props.deliverables?.map((res: any, index: number) => {
                  if (res?.deliverable_item === "ig_reel") {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Reel</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value && (
                          <>
                            {(props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                                <>
                                  <TableCell>
                                    <InputField
                                      index={index}
                                      qty={res.qty}
                                      skipAdd={false}
                                      handleCost={props.handleCost}
                                    />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                  </TableCell>
                                  {/* <TableCell><TextField
                                    size='small'
                                    disabled
                                    label=""
                                    defaultValue={res.price}
                                    value={res.price}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                    }}
                                  />
                                  </TableCell> */}
                                  <TableCell className='switch-cell'>
                                    <SwitchButton
                                      handleSwitch={props.handleSwitch}
                                      index={index}
                                    />
                                  </TableCell>
                                </>
                              )}
                          </>
                        )}
                      </TableRow>
                    );
                  } else if (res.deliverable_item === "ig_story") {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Story</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}

                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                /></TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (
                    res.deliverable_item === "ig_static"
                  ) {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>
                          Static <br className='d-md-none' />  (No. of images - {
                            props.deliverables.filter((item: any) => item.deliverable_item === "ig_static_image")[0]?.qty
                          })
                        </TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell> <TextField
                                size='small'
                                disabled
                                id="outlined-disabled"
                                label=""
                                defaultValue={res.price}
                                value={res.price}
                                InputProps={{
                                  startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                }}
                              /></TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (res.deliverable_item === "yt_shorts") {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Shorts</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                
                                <CurrencyRupee fontSize="small" />{" "}
                                    {res.price}
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                />

                              </TableCell> */}
                              <TableCell className='switch-cell' width={100}>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (
                    res.deliverable_item === "yt_dedicated_video"
                  ) {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Dedicated Video</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                />
                              </TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (
                    res.deliverable_item === "yt_integrated_video"
                  ) {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell>Integrated Video</TableCell>
                        <TableCell>{res.qty}</TableCell>
                        {props.campaign_cost_model_value &&
                          (props.campaignDetail.campaign_type + "")
                            .toLocaleLowerCase()
                            .includes("paid") && (
                            <>
                              <TableCell>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={false}
                                  handleCost={props.handleCost}
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              {/* <TableCell>
                                <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                />
                              </TableCell> */}
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </>
                          )}
                      </TableRow>
                    );
                  } else if (res.deliverable_item === "digital_rights") {
                    return (
                      <>
                        <TableRow className="common-table-blank-row">
                          <TableCell colSpan={5} className='p-0'><hr /></TableCell>
                        </TableRow>
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell className='pb-0'>Digital Rights <br/>
                            <span style={{color:'#757575'}}>
                              ({res.qty} days)
                            </span>
                          </TableCell>
                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={true}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell> {res.price}</TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                        
                      </>
                    );
                  } else if (
                    res.deliverable_item === "available_for_exclusivity"
                  ) {
                    return (
                      <>
                        <TableRow>
                          <TableCell className='pb-0'>Exclusivity <br /><span style={{color:'#757575'}}>({res.qty} Days)</span></TableCell>
                          <TableCell className='pb-0'></TableCell>
                           {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={true}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell> {res.price}</TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                        
                        {props.campaignDetail.campaign_type === "Barter" && 
                          <TableRow>
                            <TableCell className='pb-0' colSpan={4}>&nbsp;</TableCell>
                          </TableRow>
                        }
                        {/* <TableRow className="common-table-blank-row">
                          <TableCell colSpan={5} className='p-0'><hr /></TableCell>
                        </TableRow> */}
                      </>
                    );
                  }

                  return null;
                })}
              {/* PACKAGE COST */}
              {!props.campaign_cost_model_value && (
                <>
                  {props.deliverables?.length > 0 && props.deliverables &&
                    props.deliverables?.map((res: any, index: number) => {
                      if (
                        (res.deliverable_item + "").toLocaleLowerCase() ===
                        "package cost 1"
                      ) {
                        return (
                          <>
                          <TableRow className='row-package-cost'
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell>{res.deliverable_item} </TableCell>

                            
                            {/* <> */}
                            <TableCell colSpan={2}>
                              <InputField
                                index={index}
                                qty={res.qty}
                                skipAdd={true}
                                handleCost={props.handleCost}
                                placeholder="0"
                              />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                            </TableCell>
                            
                            
                            {/* </> */}

                          </TableRow>
                          <TableRow>
                          <TableCell>Is this cost negotiable? </TableCell>
                            <TableCell className='switch-cell'>
                              <SwitchButton
                                handleSwitch={props.handleSwitch}
                                index={index}
                              />
                            </TableCell>
                          </TableRow>
                          </>

                        );
                      }

                      return null; // JSON.stringify(deliverables);
                    })}
                </>

              )}

           

            </TableBody>


          </Table>
        </TableContainer>

{/* {props.deliverables?.map((res: any, index: number) => {
  const isPaid =
    props.campaign_cost_model_value &&
    (props.campaignDetail.campaign_type + "")
      .toLowerCase()
      .includes("paid");

  // Common Row UI
  const renderRow = (label: string, extra?: any) => (
    <div className="mobile-table-row" key={index}>
      <div className="row-top">
        <span className='row-top-deliverable'>{label}</span>
        {res.qty && <span className='row-top-deliverable'>{res.qty}</span>}
      </div>

      {extra}

      {isPaid && (
        <>
          <InputField
            index={index}
            qty={res.qty}
            skipAdd={false}
            handleCost={props.handleCost}
          />
          {props.costPerUnitError && (
            <span className="error pt-1">
              {props.costPerUnitError.message}
            </span>
          )}
          <SwitchButton
            handleSwitch={props.handleSwitch}
            index={index}
          />
        </>
      )}
    </div>
  );

  // 👉 IG Reel
  if (res.deliverable_item === "ig_reel") {
    return renderRow("Reel");
  }

  // 👉 IG Story
  if (res.deliverable_item === "ig_story") {
    return renderRow("Story");
  }

  // 👉 IG Static
  if (res.deliverable_item === "ig_static") {
    const staticQty =
      props.deliverables.find(
        (item: any) => item.deliverable_item === "ig_static_image"
      )?.qty || 0;

    return renderRow(`Static Images - ${staticQty}`);
  }

  // 👉 YouTube Shorts
  if (res.deliverable_item === "yt_shorts") {
    return renderRow("Shorts");
  }

  // 👉 Dedicated Video
  if (res.deliverable_item === "yt_dedicated_video") {
    return renderRow("Dedicated Video");
  }

  // 👉 Integrated Video
  if (res.deliverable_item === "yt_integrated_video") {
    return renderRow("Integrated Video");
  }

  // 👉 Digital Rights
  if (res.deliverable_item === "digital_rights") {
    return (
      <div className="mobile-table-row" key={index}>
        <div className="row-top">
          <span className='row-top-deliverable'>Digital Rights ({res.qty} days)</span>
        </div>

        {isPaid && (
          <>
            <InputField
              index={index}
              qty={res.qty}
              skipAdd={true}
              handleCost={props.handleCost}
            />
            {props.costPerUnitError && (
              <span className="error pt-1">
                {props.costPerUnitError.message}
              </span>
            )}
            <SwitchButton
              handleSwitch={props.handleSwitch}
              index={index}
            />
          </>
        )}
      </div>
    );
  }

  // 👉 Exclusivity
  if (res.deliverable_item === "available_for_exclusivity") {
    return (
      <div className="mobile-table-row" key={index}>
        <div className="row-top">
          <span className='row-top-deliverable'>Exclusivity ({res.qty} days)</span>
        </div>

        {isPaid && (
          <>
            <InputField
              index={index}
              qty={res.qty}
              skipAdd={true}
              handleCost={props.handleCost}
            />
            {props.costPerUnitError && (
              <span className="error pt-1">
                {props.costPerUnitError.message}
              </span>
            )}
            <SwitchButton
              handleSwitch={props.handleSwitch}
              index={index}
            />
          </>
        )}
      </div>
    );
  }

  return null;
})} */}
 
{/* {!props.campaign_cost_model_value &&
  props.deliverables?.map((res: any, index: number) => {
    if (res.deliverable_item?.toLowerCase() === "package cost 1") {
      return (
        <div className="mobile-table-row" key={index}>
          <div className="row-top">
            <span className="row-top-deliverable">Total Cost</span>

            <span className="total-cost-field">
              <InputField
                index={index}
                qty={res.qty}
                skipAdd={true}
                handleCost={props.handleCost}
                placeholder="0"
              />
            </span>
          </div>

          {props.costPerUnitError?.status && (
            <span className="error pt-1">
              {props.costPerUnitError.message}
            </span>
          )}

          <div className="row-top">
            <span>Is this cost negotiable?</span>
            <SwitchButton
              className="proposal-switch"
              handleSwitch={props.handleSwitch}
              index={index}
            />
          </div>
        </div>
      );
    }
    return null;
  })} */}

{/* 👉 PACKAGE COST */}
{/* {!props.campaign_cost_model_value &&
  props.deliverables?.map((res: any, index: number) => {
    if (
      (res.deliverable_item + "").toLowerCase() === "package cost 1"
    ) {
      return (
        <div className="mobile-table-row" key={index}>
          <div className="row-top">
            <span className='row-top-deliverable'>{(res.deliverable_item.toLowerCase()) === 'package cost 1' ? "Total Cost" : res.deliverable_item}</span>
            <span className='total-cost-field'>
            <InputField
            index={index}
            qty={res.qty}
            skipAdd={true}
            handleCost={props.handleCost}
            placeholder="0"
            
          />
          </span>
          {props.costPerUnitError && (
            <span className="error pt-1">
              {props.costPerUnitError.message}
            </span>
          )}
          </div>

          

          <div className="row-top">
            <span>Is this cost negotiable?</span>
            <SwitchButton
            className='proposal-switch'
            handleSwitch={props.handleSwitch}
            index={index}
          />
          </div>

          
        </div>
      );
    }
    return null;
  })} */}

{/* 👉 TOTAL */}
{/* {props.campaignDetail.campaign_type !== "Barter" && (
  <div className="mobile-table-row total-row">
    <div className="row-top">
      <span className='row-top-deliverable'><strong>Total Amount 123</strong></span>
    </div>
<span className='total-cost-field'>
    <TextField
      size="small"
      className="w-100"
      disabled
      value={props.totalAmount}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">₹</InputAdornment>
        ),
      }}
    />
    </span>
  </div>
)} */}
<div className='mobile-proposal-comments d-md-none'>
          {/* {proposalStatus > 1 && ( */}
          {/* <strong className="d-block">Comments</strong> */}
          {/* <ul>
            {props.proposalChats &&
              props.proposalChats?.map((data: any, index: number) => {
                return (
                  <li key={index}>
                    <span>{dayjs(data.created_at).format("LL")}</span>
                    <span>{data.account_id === props.userReducer.account_id ? 'You' : props.userReducer.account_name}</span>
                    <span>{data.comments}</span>
                  </li>
                );
              })}
          </ul> */}
          <label className='comments'>Comments</label>
          <TextField
            className="w-100 mb-4"
            id="outlined-multiline-static"
            label=""
            placeholder='Share your thoughts, profile details, or add relevant campaign links here...'
            multiline
            rows={2}
            value={props.comment}
            onChange={(e) => props.setComment(e.target.value)}
          />
          <div className="row">
            <div className="col terms_conditions">
              <span>
                <FormControlLabel
                  className='custom-checkbox m-0'
                  control={
                    <Checkbox
                      className='p-0'
                      onChange={(e, v) => props.setCheckTermsCheckBox(v)}
                    />
                  }
                  label={<Typography className='d-flex align-items-center flex-wrap'>
                    I agree to the <Link to={`${BASE_URL_UI}/terms_condition`} className='btn btn-text-link ms-1' target='_blank'>Terms &amp; Conditions</Link>&nbsp;and <Link to={`${BASE_URL_UI}/privacy_policy`} className='btn btn-text-link ms-1'  target='_blank'>Privacy Policy</Link>
                  </Typography>}
                />
              </span>
              {props.errorTerms && (
                <span className="error pt-1">Terms & Conditions are required</span>
              )}
            </div>
          </div>
          <div className="row apply-btn">
          
            <div className="col flex-1 d-flex proposal-footer">
                {props.campaignDetail.campaign_type !== "Barter" && (
              <div className="total-row">
                
                <span className=''>
                  <TextField
                    size="small"
                    disabled
                    value={props.totalAmount}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      ),
                    }}
                  />
                  </span>
                  <div className="row-top">
                    <span className='row-top-deliverable'><span>Total Amount </span></span>
                  </div>
              </div>
            )}
            <div className='text-end flex-1  d-flex justify-content-end gap-2 items-center'>
              <LoadingButton

                className="btn btn-outline-primary btn-lg btn-cancel"
                loading={props.loading}
                loadingPosition="start"
                variant="contained"
                onClick={props.handleCancel}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                className="btn btn-lg btn-submit"
                loading={props.loading}
                loadingPosition="start"
                variant="contained"
                // onClick={handleClickApplyOpen}
                onClick={() => {
                  props.handleApply();
                }}
                disabled={!props.checkTermsCheckbox}
              >
                Submit
              </LoadingButton>
            </div>
            </div>
          </div>


        </div>
          </div>
            
            </>
          ) : (
          <TableContainer
            className="common-table bdr-rad-0"
          >
            <Table
              stickyHeader
              aria-label="simple table"
            >
              <TableHead className='common-table-header'>
                <TableRow>
                  <TableCell align="left">
                    Deliverables
                  </TableCell>
                  <TableCell align="left">Qty</TableCell>
                  {props.campaign_cost_model_value && (
                    <>
                      {(props.campaignDetail.campaign_type + "")
                        .toLocaleLowerCase()
                        .includes("paid") && (
                          <>
                            <TableCell align="left" style={{minWidth:'150px'}}>Cost per Unit</TableCell>
                          {/* <TableCell align="left" style={{minWidth:"180px"}}>Total Cost</TableCell> */}
                      <TableCell align="left" style={{minWidth:"100px", paddingLeft:'0', paddingRight:'0'}}>Is this cost negotiable?</TableCell>
                          </>
                        )}
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody className="common-table-body">
                {(props.deliverables?.length > 0) && props.deliverables &&
                  props.deliverables?.map((res: any, index: number) => {
                    if (res?.deliverable_item === "ig_reel") {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>Reel</TableCell>
                          <TableCell>{res.qty}</TableCell>
                          {props.campaign_cost_model_value && (
                            <>
                              {(props.campaignDetail.campaign_type + "")
                                .toLocaleLowerCase()
                                .includes("paid") && (
                                  <>
                                    <TableCell>
                                      <InputField
                                        index={index}
                                        qty={res.qty}
                                        skipAdd={false}
                                        handleCost={props.handleCost}
                                      />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                    </TableCell>
                                    {/* <TableCell><TextField
                                      size='small'
                                      disabled
                                      label=""
                                      defaultValue={res.price}
                                      value={res.price}
                                      InputProps={{
                                        startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                      }}
                                    />
                                    </TableCell> */}
                                    <TableCell className='switch-cell'>
                                      <SwitchButton
                                        handleSwitch={props.handleSwitch}
                                        index={index}
                                      />
                                    </TableCell>
                                  </>
                                )}
                            </>
                          )}
                        </TableRow>
                      );
                    } else if (res.deliverable_item === "ig_story") {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>Story</TableCell>
                          <TableCell>{res.qty}</TableCell>
                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={false}
                                    handleCost={props.handleCost}

                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell>
                                  <TextField
                                    size='small'
                                    disabled
                                    id="outlined-disabled"
                                    label=""
                                    defaultValue={res.price}
                                    value={res.price}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                    }}
                                  /></TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                      );
                    } else if (
                      res.deliverable_item === "ig_static"
                    ) {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>
                            Static <br className='d-md-none' />  Images - {
                              props.deliverables.filter((item: any) => item.deliverable_item === "ig_static_image")[0]?.qty
                            }
                          </TableCell>
                          <TableCell>{res.qty}</TableCell>
                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={false}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell> <TextField
                                  size='small'
                                  disabled
                                  id="outlined-disabled"
                                  label=""
                                  defaultValue={res.price}
                                  value={res.price}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                  }}
                                /></TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                      );
                    } else if (res.deliverable_item === "yt_shorts") {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>Shorts</TableCell>
                          <TableCell>{res.qty}</TableCell>
                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={false}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell>
                                  
                                  <CurrencyRupee fontSize="small" />{" "}
                                      {res.price}
                                  <TextField
                                    size='small'
                                    disabled
                                    id="outlined-disabled"
                                    label=""
                                    defaultValue={res.price}
                                    value={res.price}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                    }}
                                  />

                                </TableCell> */}
                                <TableCell className='switch-cell' width={100}>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                      );
                    } else if (
                      res.deliverable_item === "yt_dedicated_video"
                    ) {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>Dedicated Video</TableCell>
                          <TableCell>{res.qty}</TableCell>
                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={false}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell>
                                  <TextField
                                    size='small'
                                    disabled
                                    id="outlined-disabled"
                                    label=""
                                    defaultValue={res.price}
                                    value={res.price}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                    }}
                                  />
                                </TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                      );
                    } else if (
                      res.deliverable_item === "yt_integrated_video"
                    ) {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell>Integrated Video</TableCell>
                          <TableCell>{res.qty}</TableCell>
                          {props.campaign_cost_model_value &&
                            (props.campaignDetail.campaign_type + "")
                              .toLocaleLowerCase()
                              .includes("paid") && (
                              <>
                                <TableCell>
                                  <InputField
                                    index={index}
                                    qty={res.qty}
                                    skipAdd={false}
                                    handleCost={props.handleCost}
                                  />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                </TableCell>
                                {/* <TableCell>
                                  <TextField
                                    size='small'
                                    disabled
                                    id="outlined-disabled"
                                    label=""
                                    defaultValue={res.price}
                                    value={res.price}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                                    }}
                                  />
                                </TableCell> */}
                                <TableCell className='switch-cell'>
                                  <SwitchButton
                                    handleSwitch={props.handleSwitch}
                                    index={index}
                                  />
                                </TableCell>
                              </>
                            )}
                        </TableRow>
                      );
                    } else if (res.deliverable_item === "digital_rights") {
                      return (
                        <>
                          <TableRow className="common-table-blank-row">
                            <TableCell colSpan={5} className='p-0'><hr /></TableCell>
                          </TableRow>
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell className='pb-0' colSpan={4}>Cost for  Digital Rights {res.qty} days</TableCell>
                          </TableRow>
                          <TableRow
                            key={index}
                            className='pt-0'
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >

                            {props.campaign_cost_model_value &&
                              (props.campaignDetail.campaign_type + "")
                                .toLocaleLowerCase()
                                .includes("paid") && (
                                <>
                                  <TableCell colSpan={3}>
                                    <InputField
                                      index={index}
                                      qty={res.qty}
                                      skipAdd={true}
                                      handleCost={props.handleCost}
                                    />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                  </TableCell>
                                  {/* <TableCell> {res.price}</TableCell> */}
                                  <TableCell className='switch-cell'>
                                    <SwitchButton
                                      handleSwitch={props.handleSwitch}
                                      index={index}
                                    />
                                  </TableCell>
                                </>
                              )}
                          </TableRow>
                        </>
                      );
                    } else if (
                      res.deliverable_item === "available_for_exclusivity"
                    ) {
                      return (
                        <>
                          <TableRow>
                            <TableCell className='pb-0' colSpan={4}>Cost for {res.qty} Days Exclusivity</TableCell>
                          </TableRow>
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            {props.campaign_cost_model_value &&
                              (props.campaignDetail.campaign_type + "")
                                .toLocaleLowerCase()
                                .includes("paid") && (
                                <>
                                  <TableCell colSpan={3}>
                                    <InputField
                                      index={index}
                                      qty={res.qty}
                                      skipAdd={true}
                                      handleCost={props.handleCost}
                                    />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                                  </TableCell>
                                  {/* <TableCell> {res.price}</TableCell> */}
                                  <TableCell className='switch-cell'>
                                    <SwitchButton
                                      handleSwitch={props.handleSwitch}
                                      index={index}
                                    />
                                  </TableCell>
                                </>
                              )}
                          </TableRow>
                          {props.campaignDetail.campaign_type === "Barter" && 
                            <TableRow>
                              <TableCell className='pb-0' colSpan={4}>&nbsp;</TableCell>
                            </TableRow>
                          }
                          {/* <TableRow className="common-table-blank-row">
                            <TableCell colSpan={5} className='p-0'><hr /></TableCell>
                          </TableRow> */}
                        </>
                      );
                    }

                    return null;
                  })}
                {/* PACKAGE COST */}
                {!props.campaign_cost_model_value && (
                  <>
                    {props.deliverables?.length > 0 && props.deliverables &&
                      props.deliverables?.map((res: any, index: number) => {
                        if (
                          (res.deliverable_item + "").toLocaleLowerCase() ===
                          "package cost 1"
                        ) {
                          return (
                            <>
                            <TableRow className='row-package-cost'
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell>{res.deliverable_item} </TableCell>

                              
                              {/* <> */}
                              <TableCell colSpan={2}>
                                <InputField
                                  index={index}
                                  qty={res.qty}
                                  skipAdd={true}
                                  handleCost={props.handleCost}
                                  placeholder="0"
                                />{props.costPerUnitError && <span className="error pt-1">{props.costPerUnitError.message}</span>}
                              </TableCell>
                              
                              
                              {/* </> */}

                            </TableRow>
                            <TableRow>
                            <TableCell>Is this cost negotiable? </TableCell>
                              <TableCell className='switch-cell'>
                                <SwitchButton
                                  handleSwitch={props.handleSwitch}
                                  index={index}
                                />
                              </TableCell>
                            </TableRow>
                            </>

                          );
                        }

                        return null; // JSON.stringify(deliverables);
                      })}
                  </>

                )}

                {
                  props.campaignDetail.campaign_type !== "Barter" && (
                    <>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell className='py-3' colSpan={!props.campaign_cost_model_value ? 1 : 1}><strong>Total Amount:</strong>{" "}</TableCell>
                        <TableCell className='py-3' colSpan={!props.campaign_cost_model_value ? 1 : 2}>
                          <TextField
                            size='small'
                            className='w-100'
                            disabled
                            label=""
                            defaultValue={props.totalAmount}
                            value={props.totalAmount}
                            InputProps={{
                              startAdornment: <InputAdornment position="start"><CurrencyRupee className='fs-18' /></InputAdornment>,
                            }}
                          />
                        </TableCell>
                        {props?.campaign_cost_model?.includes("Package") && <TableCell>&nbsp;</TableCell>}
                      </TableRow>
                    </>
                  )
                }

              </TableBody>


            </Table>
          </TableContainer>
        )}
      </div>
      <div className='submit-proposal-card d-none d-md-flex'>
        <div className='mobile-proposal-comments'>
          {/* {proposalStatus > 1 && ( */}
          {/* <strong className="d-block">Comments</strong> */}
          {/* <ul>
            {props.proposalChats &&
              props.proposalChats?.map((data: any, index: number) => {
                return (
                  <li key={index}>
                    <span>{dayjs(data.created_at).format("LL")}</span>
                    <span>{data.account_id === props.userReducer.account_id ? 'You' : props.userReducer.account_name}</span>
                    <span>{data.comments}</span>
                  </li>
                );
              })}
          </ul> */}
          <TextField
            className="w-100 mb-4"
            id="outlined-multiline-static"
            label="Comments"
            placeholder='Share your thoughts, profile details, or add relevant campaign links here...'
            multiline
            rows={2}
            value={props.comment}
            onChange={(e) => props.setComment(e.target.value)}
          />
          <div className="row">
            <div className="col terms_conditions">
              <span>
                <FormControlLabel
                  className='custom-checkbox m-0'
                  control={
                    <Checkbox
                      className='p-0'
                      onChange={(e, v) => props.setCheckTermsCheckBox(v)}
                    />
                  }
                  label={<Typography className='d-flex align-items-end'>
                    I agree to the <Link to=" " className='btn btn-text-link ms-1'>Terms & Conditions</Link>
                  </Typography>}
                />
              </span>
              {props.errorTerms && (
                <span className="error pt-1">Terms & Conditions are required</span>
              )}
            </div>
          </div>
          <div className="row apply-btn">
          
            <div className="col flex-1 d-flex proposal-footer">
                {props.campaignDetail.campaign_type !== "Barter" && (
              <div className="mobile-table-row total-row d-md-none">
                
                <span className=''>
                  <TextField
                    size="small"
                    disabled
                    value={props.totalAmount}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      ),
                    }}
                  />
                  </span>
                  <div className="row-top">
                    <span className='row-top-deliverable'><span>Total Amount </span></span>
                  </div>
              </div>
            )}
            <div className='text-end flex-1  d-flex justify-content-end gap-2 items-center'>
              <LoadingButton

                className="btn btn-outline-primary btn-rounded btn-lg"
                loading={props.loading}
                loadingPosition="start"
                variant="contained"
                onClick={props.handleCancel}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                className="btn btn-primary btn-rounded btn-lg"
                loading={props.loading}
                loadingPosition="start"
                variant="contained"
                // onClick={handleClickApplyOpen}
                onClick={() => {
                  props.handleApply();
                }}
                disabled={!props.checkTermsCheckbox}
              >
                Apply
              </LoadingButton>
            </div>
            </div>
          </div>


        </div>
      </div>

    </div>
    
      </>
  )
}

export default SubmitAProposal
